import React, { useState, useEffect } from "react";
import Chat from "./Chat";
import ChatMobile from "./ChatMobile";

const ChatWrapper = (props) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 900);
    };

    // Check initial screen size
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener("resize", checkScreenSize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  // Render ChatMobile for screens <= 900px, Chat for screens > 900px
  return isMobile ? <ChatMobile {...props} /> : <Chat {...props} />;
};

export default ChatWrapper;
